import React from 'react';
import './UpdateAvailableBanner.css';
import { reloadApp } from '../utils/versionCheck';
import Refresh from '@spectrum-icons/workflow/Refresh';

/**
 * Banner component that prompts users to refresh when a new version is available
 */
export function UpdateAvailableBanner({ show }) {
    if (!show) {
        return null;
    }

    const handleRefresh = () => {
        reloadApp();
    };

    const handleDismiss = () => {
        // Store dismissed state in sessionStorage (so it comes back if they navigate)
        sessionStorage.setItem('updateBannerDismissed', 'true');
        // Force re-render by dispatching custom event
        window.dispatchEvent(new Event('updateBannerDismissed'));
    };

    // Check if already dismissed this session
    if (sessionStorage.getItem('updateBannerDismissed') === 'true') {
        return null;
    }

    return (
        <div className="update-banner">
            <div className="update-banner-content">
                <span className="update-banner-icon">
                    <Refresh size={'XXS'} />
                </span>
                <span className="update-banner-text">A new version of Commandersalt is available!</span>
                <div className="update-banner-actions">
                    <button className="update-banner-button update-banner-button-primary" onClick={handleRefresh}>
                        Refresh Now
                    </button>
                    <button className="update-banner-button update-banner-button-secondary" onClick={handleDismiss}>
                        Later
                    </button>
                </div>
            </div>
        </div>
    );
}
